<script setup lang="ts">
  import PosUiButton from '@/components/pos-v2/ui/PosUiButton.vue';
  import PosUiInput from '@/components/pos-v2/ui/PosUiInput.vue';
  import { addDays } from '@/domain/reservations/reservation-time';
  defineProps<{ value: string; today: string }>();
  const emit = defineEmits<{ (event: 'input', date: string): void }>();
  function choose(date: string) {
    try {
      emit('input', addDays(date, 0));
    } catch {
      /* Native picker may briefly be empty. */
    }
  }
</script>

<template>
  <div class="date-nav">
    <PosUiButton
      color="neutral"
      variant="ghost"
      icon="chevron-left"
      :aria-label="$t('reservations.bar.prevDay')"
      :title="$t('reservations.bar.prevDay')"
      @click="choose(addDays(value, -1))"
    />
    <PosUiButton
      color="neutral"
      :variant="value === today ? 'soft' : 'outline'"
      @click="choose(today)"
      >{{ $t('reservations.bar.today') }}</PosUiButton
    >
    <PosUiButton
      color="neutral"
      variant="ghost"
      icon="chevron-right"
      :aria-label="$t('reservations.bar.nextDay')"
      :title="$t('reservations.bar.nextDay')"
      @click="choose(addDays(value, 1))"
    />
    <PosUiInput
      class="date-picker"
      type="date"
      :value="value"
      :aria-label="$t('reservations.form.date')"
      @input="choose"
    />
  </div>
</template>

<style scoped lang="scss">
  .date-nav {
    @apply tw-flex tw-min-w-0 tw-items-center;
    .date-picker {
      @apply tw-ml-1 tw-w-[8.5rem] tw-min-w-0 md:tw-w-[9.5rem];
    }
  }
</style>
